module.exports = __webpack_public_path__ + "img/my88-fm.6f2b833b.png";